import { styled } from '@linaria/react';

import { uiToken } from '~/shared/constants/uiToken';
import { Typography } from '~/shared/ui/Typography/Typography';

export type CardSize = 's' | 'l';

export const Root = styled.button`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  cursor: pointer;
  width: 100%;
  border: none;
  background: transparent;
  padding: 0;
  position: relative;

  &:disabled {
    cursor: default;
    pointer-events: none;
  }

  &:focus {
    outline: none;
  }

  &:focus-visible:not(:disabled)::before {
    content: '';
    position: absolute;
    inset: 4px;
    border: 2px solid ${uiToken.color.border.glassActive};
    border-radius: 8px;
    pointer-events: none;
    z-index: 1;
  }
`;

export const Icon = styled.img`
  max-width: 50%;
  max-height: 50%;
`;

export const IconImage = styled.img`
  width: 100%;
  object-fit: contain;
  border-radius: 12px;
  border: 4px solid #ffffff26;
`;

export const Name = styled(Typography.Text)`
  color: #ffffffe6;
  padding: 8px 4px;
`;

export const IconName = styled.div`
  width: 100%;
  aspect-ratio: 1.78;
  font-weight: 600;
  padding: 0 16px;
  text-align: center;
  border: 4px solid #ffffff26;
  border-radius: 12px;
  object-fit: contain;
  display: flex;
  align-items: center;
  justify-content: center;
`;
